import React from 'react';
import LocationTemplate from './LocationTemplate';

const MicroPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Micro"
      stateName="North Carolina"
      countyName="Johnston"
      zipCodes={["27555"]}
      latitude={35.5715}
      longitude={-78.2003}
      population={610}
      historicalFact="One of the smallest incorporated towns in North Carolina, fittingly named 'Micro.'"
      nearbyTowns={[
        "Selma, NC",
        "Kenly, NC",
        "Princeton, NC",
        "Pine Level, NC",
        "Four Oaks, NC",
        "Wilson, NC",
        "Lucama, NC",
        "Middlesex, NC"
      ]}
    />
  );
};

export default MicroPage;